/* QQ homepage: slideshow, what's new tabs, setup hotspots. Works in the theme editor too. */
(function () {
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function slideshow(root) {
    if (root.dataset.qqhReady) return; root.dataset.qqhReady = '1';
    var slides = root.querySelectorAll('[data-qqh-slide]'), dots = root.querySelectorAll('[data-qqh-dot]');
    if (slides.length < 2) return;
    var i = 0, timer = null, delay = (parseInt(root.dataset.delay, 10) || 5) * 1000;
    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { var on = k === i; s.classList.toggle('is-active', on); s.setAttribute('aria-hidden', on ? 'false' : 'true'); s.querySelectorAll('a').forEach(function (a) { a.tabIndex = on ? 0 : -1; }); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); if (k === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
    }
    function play() { stop(); if (root.dataset.autoplay === 'true' && !reduce) timer = setInterval(function () { go(i + 1); }, delay); }
    function stop() { if (timer) clearInterval(timer); timer = null; }
    dots.forEach(function (d) { d.addEventListener('click', function () { go(+d.dataset.qqhDot); play(); }); });
    root.addEventListener('mouseenter', stop); root.addEventListener('mouseleave', play);
    root.addEventListener('focusin', stop); root.addEventListener('focusout', play);
    var sx = null;
    root.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) { if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) { go(i + (dx < 0 ? 1 : -1)); play(); } sx = null; });
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : play(); });
    root.addEventListener('shopify:block:select', function (e) { var k = Array.prototype.indexOf.call(slides, e.target); if (k > -1) { go(k); stop(); } });
    go(0); play();
  }

  function restart(el) { el.classList.remove('is-entering'); void el.offsetWidth; el.classList.add('is-entering'); }

  function tabs(root) {
    if (root.dataset.qqhReady) return; root.dataset.qqhReady = '1';
    var btns = Array.prototype.slice.call(root.querySelectorAll('[role=tab]'));
    var heading = root.querySelector('[data-qqh-heading]'), note = root.querySelector('[data-qqh-note]');
    var link = root.querySelector('[data-qqh-link]'), linkLabel = root.querySelector('[data-qqh-link-label]');
    function select(b, focus) {
      btns.forEach(function (x) {
        var on = x === b, panel = document.getElementById(x.getAttribute('aria-controls'));
        x.setAttribute('aria-selected', on ? 'true' : 'false'); x.tabIndex = on ? 0 : -1;
        if (panel) { panel.hidden = !on; if (on) restart(panel); }
      });
      if (heading) { heading.textContent = b.dataset.heading; restart(heading); }
      if (note) { note.textContent = b.dataset.note; restart(note); }
      if (link) { link.href = b.dataset.link; link.hidden = !b.dataset.linkLabel; }
      if (linkLabel) linkLabel.textContent = b.dataset.linkLabel;
      if (focus) b.focus();
    }
    btns.forEach(function (b, k) {
      b.addEventListener('click', function () { if (b.getAttribute('aria-selected') !== 'true') select(b); });
      b.addEventListener('keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowRight') n = btns[(k + 1) % btns.length];
        if (e.key === 'ArrowLeft') n = btns[(k - 1 + btns.length) % btns.length];
        if (e.key === 'Home') n = btns[0];
        if (e.key === 'End') n = btns[btns.length - 1];
        if (n) { e.preventDefault(); select(n, true); }
      });
    });
    root.addEventListener('shopify:block:select', function (e) { if (btns.indexOf(e.target) > -1) select(e.target); });
  }

  function setup(root) {
    if (root.dataset.qqhReady) return; root.dataset.qqhReady = '1';
    function lit(n, on) {
      root.querySelectorAll('[data-qqh-spot="' + n + '"],[data-qqh-row="' + n + '"]').forEach(function (el) { el.classList.toggle('is-lit', on); });
    }
    root.querySelectorAll('[data-qqh-spot],[data-qqh-row]').forEach(function (el) {
      var n = el.dataset.qqhSpot || el.dataset.qqhRow;
      ['mouseenter', 'focus'].forEach(function (t) { el.addEventListener(t, function () { lit(n, true); }); });
      ['mouseleave', 'blur'].forEach(function (t) { el.addEventListener(t, function () { lit(n, false); }); });
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-qqh-slideshow]').forEach(slideshow);
    (scope || document).querySelectorAll('[data-qqh-tabs]').forEach(tabs);
    (scope || document).querySelectorAll('[data-qqh-setup]').forEach(setup);
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', function () { init(); }) : init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
